import { Link } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import services from "../../services"
import { useEffect, useState } from "react"
import moment from 'moment'
import Toaster from "../../components/toaster";
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
import { isIOSApp, IOS_SUBSCRIPTION_NOTE } from "../../utils/platform";

const Subscriptions = () => {
    const isMobileView = useIsMobile();
    const [subscriptionsList, setSubscriptionsList] = useState([])
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [loading, setLoading] = useState(false)

    const getSubscriptionsHandler = async () => {
        setLoading(true)
        try {
            const response = await services.Vendor.GET_ALL_VENDOR_SUBSCRIPTIONS();
            setSubscriptionsList(response.data || [])
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to fetch subscriptions",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        } finally {
            setLoading(false)
        }
    }

    const deleteSubscriptionHandler = async (id) => {
        if (!window.confirm("Are you sure you want to delete this subscription?")) {
            return;
        }
        try {
            const response = await services.Vendor.DELETE_VENDOR_SUBSCRIPTION(id);
            setToaster({
                type: "success",
                title: "Success",
                text: "Subscription deleted successfully",
                visiblity: "show",
            });
            getSubscriptionsHandler()
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to delete subscription",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    visiblity: "hide",
                });
            }, 1500)
        }
    }

    useEffect(() => {
        getSubscriptionsHandler()
    }, [])

    if (isMobileView) {
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux">
                    <MobileHeader right={<Link to="/" className="mlux-avatar"><i className="fas fa-gauge-high"></i></Link>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Your plans</div>
                        <div className="nm" style={{ fontSize: 24 }}>Subscriptions</div>
                    </div>

                    {subscriptionsList && subscriptionsList.length ? subscriptionsList.map((item, i) => (
                        <Link to={`/subscriptions/${item.id}`} className="mlux-card mlux-lrow" key={i} data-rise="2">
                            <span className="lic"><i className="far fa-id-badge"></i></span>
                            <div className="lmain">
                                <div className="lt">{moment(item.startDate).format('DD MMM YY')} – {moment(item.endDate).format('DD MMM YY')}</div>
                                <div className="ls" style={{ textTransform: 'capitalize' }}>{item.modeOfPayment || 'N/A'} · Rs. {item.totalCost?.toLocaleString('en-IN')}</div>
                            </div>
                            <div className="lend"><span className={`mlux-badge ${item.isActive ? 'ok' : 'no'}`}>{item.isActive ? 'Active' : 'Inactive'}</span><i className="fas fa-chevron-right mlux-chev"></i></div>
                        </Link>
                    )) : (
                        <div className="mlux-card mlux-empty" data-rise="2">
                            <div className="ic"><i className="far fa-id-badge"></i></div>
                            <h4>No subscriptions</h4>
                            <p>{isIOSApp() ? IOS_SUBSCRIPTION_NOTE : 'Subscribe to start listing one-way availabilities.'}</p>
                            {!isIOSApp() && <Link to="/subscriptions/add" className="mlux-btn ghost" style={{ textDecoration: 'none' }}><i className="fas fa-plus"></i> Add subscription</Link>}
                        </div>
                    )}
                </main>
                {!isIOSApp() && <Link to="/subscriptions/add" className="mlux-fab"><i className="fas fa-plus"></i></Link>}
                <MobileFooter />
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />

            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">My Subscriptions</h4>
                                                <div class="user-profile-card-header-right">
                                                    <div class="user-profile-search">
                                                        <div class="form-group">
                                                            <input type="text" class="form-control" placeholder="Search..." />
                                                            <i class="far fa-search"></i>
                                                        </div>
                                                    </div>
                                                    {!isIOSApp() && <Link to={'/subscriptions/add'} class="theme-btn"><i class="far fa-plus"></i> Add Subscription</Link>}
                                                </div>
                                            </div>
                                            {loading ? (
                                                <div class="text-center py-5">
                                                    <p>Loading subscriptions...</p>
                                                </div>
                                            ) : (
                                                <div class="table-responsive">
                                                    <table class="table text-nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th>Start Date</th>
                                                                <th>End Date</th>
                                                                <th>Total Cost</th>
                                                                <th>Mode of Payment</th>
                                                                <th>Status</th>
                                                                <th>Created Date</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {subscriptionsList && subscriptionsList.length ? subscriptionsList.map((item, indx) => {
                                                                return (
                                                                    <tr key={indx}>
                                                                        <td>
                                                                            <span>{moment(item.startDate).format('DD-MM-YYYY')}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{moment(item.endDate).format('DD-MM-YYYY')}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>Rs. {item.totalCost?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span class="text-capitalize">{item.modeOfPayment || 'N/A'}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span class={`badge badge-${item.isActive ? 'success' : 'danger'}`}>
                                                                                {item.isActive ? 'Active' : 'Inactive'}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{moment(item.createdAt).format('DD-MM-YYYY, hh:mm')}</span>
                                                                        </td>
                                                                        <td>
                                                                            <Link to={`/subscriptions/${item.id}`}
                                                                                class="btn btn-outline-secondary btn-sm rounded-2"
                                                                                data-bs-toggle="tooltip" title="View Details"><i
                                                                                    class="far fa-eye"></i></Link>
                                                                            {/* <Link to={`/subscriptions/edit/${item.id}`}
                                                                                class="btn ms-2 btn-outline-secondary btn-sm rounded-2"
                                                                                data-bs-toggle="tooltip" title="Edit"><i
                                                                                    class="far fa-pencil"></i></Link>
                                                                            <button
                                                                                onClick={() => deleteSubscriptionHandler(item.id)}
                                                                                class="btn ms-2 btn-outline-danger btn-sm rounded-2"
                                                                                data-bs-toggle="tooltip" title="Delete"><i
                                                                                    class="far fa-trash"></i></button> */}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }) : (
                                                                <tr>
                                                                    <td colSpan="7" class="text-center py-5">
                                                                        <p>No subscriptions found. {isIOSApp() ? IOS_SUBSCRIPTION_NOTE : <Link to={'/subscriptions/add'}>Add your first subscription</Link>}</p>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default Subscriptions

